import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useState, useRef, useContext } from 'react';
import { Notification } from '../../components/Notification/Notification.es.js';
import { StyledNotification } from '../../components/Notification/styled.es.js';
import styled from 'styled-components';
import { zIndex, spacing } from '../../utils/theme.es.js';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Portal } from '../../primitives/Portal/Portal.es.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var BASE_NOTIFICATION_TIMEOUT = 3e3;
var NotificationContext =
/*#__PURE__*/
React.createContext({
  addNotification: function addNotification() {
    return void 0;
  }
});
var NotificationWrapper = styled.div.withConfig({
  componentId: "sc-1ynd4ce-0"
})(["align-items:center;display:flex;flex-direction:column-reverse;pointer-events:none;position:fixed;top:0;left:0;width:100%;z-index:", ";", "{pointer-events:all;margin-top:", ";}"], zIndex("alert"), StyledNotification, spacing("sm"));

var NotificationProvider = function NotificationProvider(_ref) {
  var _ref$baseNotification = _ref.baseNotificationTimeout,
      baseNotificationTimeout = _ref$baseNotification === void 0 ? BASE_NOTIFICATION_TIMEOUT : _ref$baseNotification,
      notificationsLimit = _ref.notificationsLimit,
      children = _ref.children;

  var _useState = useState(
  /* @__PURE__ */
  new Map()),
      notificationsMap = _useState[0],
      setNotifications = _useState[1];

  var notificationCounter = useRef(0);

  var incrementCounter = function incrementCounter() {
    notificationCounter.current += 1;
  };

  var decrementCounter = function decrementCounter() {
    notificationCounter.current -= 1;
  };

  var closeNotification = function closeNotification(key, shouldNotDecrementCounter) {
    if (shouldNotDecrementCounter === void 0) {
      shouldNotDecrementCounter = false;
    }

    var notification = notificationsMap.get(key);
    notification && notification.onClose && notification.onClose();
    notificationsMap.delete(key);
    !shouldNotDecrementCounter && decrementCounter();
    setNotifications(new Map(notificationsMap));
  };

  var addNotification = function addNotification(notification) {
    var isReachedNotificationLimit = notificationsLimit && notificationsMap.size === notificationsLimit;
    incrementCounter();
    var current = notificationCounter.current;
    var timeout = notification.timeout || baseNotificationTimeout;
    notificationsMap.set(current, __spreadProps(__spreadValues({}, notification), {
      timeout: timeout
    }));

    if (isReachedNotificationLimit) {
      var firstKeyValueOfTheMap = Array.from(notificationsMap.keys())[0];
      closeNotification(firstKeyValueOfTheMap, true);
    }

    setNotifications(new Map(notificationsMap));
  };

  return (
    /* @__PURE__ */
    React.createElement(NotificationContext.Provider, {
      value: {
        addNotification: addNotification
      }
    },
    /* @__PURE__ */
    React.createElement(Portal, {
      zIndex: 2e3
    },
    /* @__PURE__ */
    React.createElement(NotificationWrapper, null, _toConsumableArray(notificationsMap).map(function (_a) {
      var key = _a[0],
          _b = _a[1],
          _c = _b,
          isPersistent = _c.isPersistent,
          content = _c.content,
          _onClose = _c.onClose,
          rest = __objRest(_c, ["isPersistent", "content", "onClose"]);

      return (
        /* @__PURE__ */
        React.createElement(Notification, __spreadValues({
          key: key,
          kind: isPersistent ? "persistent" : "temporary",
          onClose: function onClose() {
            closeNotification(key);
            _onClose == null ? void 0 : _onClose();
          }
        }, rest), content)
      );
    }))), children)
  );
};

var useNotification = function useNotification() {
  var notificationContext = useContext(NotificationContext);
  var notify = notificationContext.addNotification;
  return {
    notify: notify
  };
};

export { BASE_NOTIFICATION_TIMEOUT, NotificationContext, NotificationProvider, NotificationWrapper, useNotification };